import {FilterPriceSlider} from '@/_application/modules/categories/components/category-filter/category-filter-price/filter-price-slider';
import {useTranslation} from 'next-i18next';
import React, {forwardRef, useEffect, useImperativeHandle, useState} from 'react';

type Props = {
    min: number;
    max: number;
    step: number;
    default: {
        minDefault: number;
        maxDefault: number;
    };
    onChange: (value: {min: number; max: number}) => void;
};

export type MultiRangeSliderMethods = {
    resetValues: () => void;
};

const MultiRangeSlider = forwardRef<MultiRangeSliderMethods, Props>(
    ({min, max, step, default: {minDefault, maxDefault}, onChange}, ref) => {
        const {t} = useTranslation();
        const [values, setValues] = useState<number[] | number>([]);

        useImperativeHandle(
            ref,
            () => ({
                resetValues() {
                    setValues([min, max]);
                },
            }),
            [],
        );
        const handleChangeSlider = (values: number[] | number) => {
            if (
                (Array.isArray(values) && values[0] === 0 && values[1] === 0) ||
                (typeof values === 'number' && values === 0)
            ) {
                return;
            }
            setValues(values);
        };
        useEffect(() => {
            const initialValue =
                Number.isNaN(minDefault) || Number.isNaN(maxDefault) ? [min, max] : [minDefault, maxDefault];
            setValues(initialValue);
        }, [minDefault, maxDefault]);
        useEffect(() => {
            if (Array.isArray(values)) {
                onChange({min: values[0], max: values[1]});
            }
        }, [values]);
        return (
            <div className="relative w-full">
                <div className="relative w-full px-4 py-3">
                    {/*<FilterPriceSlider min={min} max={max} step={step} value={values} onChange={handleChangeSlider} />*/}
                    <FilterPriceSlider min={min} max={max} step={step} value={values} onChange={handleChangeSlider} />
                    {Array.isArray(values) && (
                        <>
                            <span className="absolute -bottom-6 -left-2 text-sm text-gray-500 dark:text-gray-400">
                                {t('text-from')} {values[0]?.toLocaleString('vi-VN')}đ
                            </span>
                            <span className="absolute -bottom-6 -right-2 text-sm text-gray-500 dark:text-gray-400">
                                {t('text-to')} {values[1]?.toLocaleString('vi-VN')}đ
                            </span>
                        </>
                    )}

                    {/*{Array.isArray(values) && (*/}
                    {/*  <>*/}
                    {/*    <span className="absolute -bottom-6 -left-2 text-sm text-gray-500 dark:text-gray-400">*/}
                    {/*      {t('text-from')} {values[0]?.toLocaleString('vi-VN')}đ*/}
                    {/*    </span>*/}
                    {/*    <span className="absolute -bottom-6 -right-2 text-sm text-gray-500 dark:text-gray-400">*/}
                    {/*      {t('text-to')} {values[1]?.toLocaleString('vi-VN')}đ*/}
                    {/*    </span>*/}
                    {/*  </>*/}
                    {/*)}*/}
                </div>
            </div>
        );
    },
);

export default MultiRangeSlider;
